import React, { useRef } from "react"
import { Link } from "react-router-dom"
import AD3_LOGO_WHITE from "../assets/images/AD3_LOGO_WHITE.png";
import Proyecto_salesforce_v01 from "../assets/images/proyecto_salesforce_v01.jpg";
import Vadebike from "../assets/images/proyecto_vadebike.jpg";
import Proyecto_ce_v01 from "../assets/images/proyecto_ce_v01.jpg";
import Proyecto_ekadeal from "../assets/images/proyecto_ekadeal.jpg";
import Proyecto_camprodon from "../assets/images/proyecto_camprodon.jpg";
import Proyecto_hispanosuiza from "../assets/images/proyecto_hispanosuiza.jpg";
import Proyecto_chillapp from "../assets/images/proyecto_chillapp.jpg";
import Proyecto_twineagles from "../assets/images/proyecto_twineagles.jpg";
import Cuatro80 from "../assets/images/480.png";
import Peralada from "../assets/images/Peralada.png";
import Caher from "../assets/images/Caher.png";
import Quillo from "../assets/images/Quillo.png";
import Logo3 from "../assets/images/logo3.png";
import Ekamat from "../assets/images/Ekamat.png";
import Vadebike1 from "../assets/images/Vadebike.png";
import Vonpreu from "../assets/images/Vonpreu.png";
import Altech from "../assets/images/Altech.png";
import Quantum from "../assets/images/Quantum.png";
import Mahou from "../assets/images/Mahou.png";
import Adjuntament from "../assets/images/Adjuntament.png";
import Mango from "../assets/images/Mango.png";
import HispanoSuiza from "../assets/images/HispanoSuiza.png";
import Sabadell from "../assets/images/Sabadell.png";

const imgProjects = [
    {
        title: "Vadebike",
        img: Vadebike,
        description: "Vadebike",
        type: "Solución digital que potencia la micromovilidad con aparcamientos inteligentes conectados en tiempo real."
    },
    {
        title: "Círculo Ecuestre",
        img: Proyecto_ce_v01,
        description: "Círculo Ecuestre",
        type: "Desarrollo y mantenimiento de aplicaciones."
    },
    {
        title: "Ekasales",
        img: Proyecto_salesforce_v01,
        description: "Ekasales",
        type: "Herramienta móvil que optimiza la fuerza de ventas con control de pedidos, rutas y datos en tiempo real"
    },
    {
        title: "Ekadeal",
        img: Proyecto_ekadeal,
        description: "Ekadeal",
        type: "Aplicación de reparto diseñada para coordinar rutas, entregas y gestión operativa de distribución"
    },
    {
        title: "Vall de Camprodon",
        img: Proyecto_camprodon,
        description: "Vall de Camprodon",
        type: "Plataforma digital enfocada en la promoción y gestión de servicios para el territorio de la Vall de Camprodon"
    },
    {
        title: "Hispanosuiza",
        img: Proyecto_hispanosuiza,
        description: "Hispanosuiza",
        type: "Solución digital para acompañar la presencia de la marca Hispano-Suiza mediante herramientas tecnológicas a medida"
    },
    {
        title: "Chillapp",
        img: Proyecto_chillapp,
        description: "Chillapp",
        type: "Aplicación para encuentros entre personas con intereses comunes."
    },

    {
        title: "Twin Eagles",
        img: Proyecto_twineagles,
        description: "Twin Eagles",
        type: "Aplicación para controlar el funcionamiento de una barbacoa inteligente"
    }
]
const clients = [
    {
        title: "Cuatro80",
        img: Cuatro80,

    },
    {
        title: "Caher",
        img: Caher,

    },
    {
        title: "Caher",
        img: Peralada,

    },
    {
        title: "Quillo",
        img: Quillo,

    },
    {
        title: "Logo3",
        img: Logo3
    },
    {
        title: "Ekamat",
        img: Ekamat
    },
    {
        title: "Vadebike",
        img: Vadebike1
    },
    {
        title: "Vonpreu",
        img: Vonpreu
    },
    {
        title: "Altech",
        img: Altech
    },
    {
        title: "Mahou",
        img: Mahou
    },
    {
        title: "Quantum",
        img: Quantum
    },
    {
        title: "Mango",
        img: Mango
    },
    {
        title: "Adjuntament",
        img: Adjuntament
    },
    {
        title: "Hispano suiza",
        img: HispanoSuiza
    },
    {
        title: "Sabadell",
        img: Sabadell
    }
]
const Home = () => {
    const contactaRef = useRef(null);
    const acercaRef = useRef(null);
    const proyectosRef = useRef(null);
    return (
        <div>
             <div style={hr} id="proyectos"  ref={proyectosRef} />
            <section style={containerProjects}>
                <h1 style={title}>Proyectos</h1>
                <div style={imageContainer}>
                    {
                        imgProjects.map((item, index) => {
                            return (
                                <div key={index} style={index > 2 ? contImgTop : contImg}>
                                    <img key={item.title} src={item.img} alt={item.title} style={(index) % 3 === 1 ? imgProjectMedium : imgProject} />
                                    <div style={textDescription}>{item.description}</div>
                                    <div style={textType}>{item.type}</div>
                                </div>

                            )
                        })
                    }
                </div>
            </section>
            <div style={hr} id="acerca" ref={acercaRef} />
            <section style={containerAcerca} >
                <h2 style={textAcerca}>Acerca de</h2>
                <p style={textDetailAcerca}>Somos un equipo especializado en el desarrollo de aplicaciones móviles, con más de 10 años de experiencia en el sector y con ilusión de seguir haciéndolo.</p>
                <p style={textDetailAcerca}>Desarrollamos el proyecto desde inicio a fin, desde que solo es una idea hasta las mejoras necesarias una vez ya publicada.</p>
                <p style={textDetailAcerca}>Nos involucramos totalmente en el proyecto de nuestro cliente para poder ofrecer lo mejor de nosotros, trabajando como un único equipo.</p>
                <p style={textDetailAcerca}>Trabajamos con la máxima transparecencia y con todo el detalle del estado del proyecto para que nuestro cliente se sienta con la máxima visibilidad.</p>
            </section>
            <section style={containerClients}>
                <h1 style={textClients}>Algunos de nuestros clientes</h1>
                <div style={imageContainerClients}>
                    {
                        clients.map((item, index) => {
                            return (
                                <div key={index} style={contImgClients}>
                                    <img key={item.title} src={item.img} alt={item.title} style={imgClient} />
                                </div>
                            )
                        })
                    }
                </div>
            </section>
            <section style={containerContacta} id="contacta" ref={contactaRef}>
                <h1 style={textcontacta}>¿Tienes un proyecto en mente?</h1>
                <p style={textDetailAcerca}>Cuéntanos qué necesitas y estudiamos cómo ayudarte. En AD3 desarrollamos
                    soluciones tecnológicas a medida —web, aplicaciones móviles e integraciones— adaptadas a tu negocio.
                    Escríbenos y te respondemos lo antes posible.</p>
                <button style={buttonContacta} onClick={() => { window.location.href = "mailto:info@ad3soft.com" }}>Contacta</button>
            </section>
            <section style={containerPie}>
                <div style={contPie}>
                    <img src={AD3_LOGO_WHITE} alt="LOGO AD3 white" width={110} />
                    <div>
                        <div style={textDetailCorreo}>info@ad3soft.com</div>
                        <div style={textDetailTlf}>Tlf. +34 658 839 599</div>
                    </div>
                </div>
                <div style={legalLinks}>
                    <Link to="/aviso-legal" style={legalLink}>Aviso Legal</Link>
                    <Link to="/privacidad" style={legalLink}>Política de Privacidad</Link>
                    <Link to="/cookies" style={legalLink}>Política de Cookies</Link>
                </div>
            </section>
        </div>
    )
}
export default Home;

const containerProjects: any = {
    marginLeft: window.innerWidth <= 1058 ? 10 : 30,
    marginRight: window.innerWidth <= 1058 ? 10 : 30,
}
const title: any = {
    marginLeft: 10,
}
const imageContainer: any = {
    display: "flex",
    justifyContent: "flex-start",
    flexWrap: "wrap",
}
const imageContainerClients: any = {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
   
    alignItems: "center",
    margin: "0 auto",
    width: window.innerWidth <= 1058 ? "90%" : "75%",
    marginLeft: "auto",
    marginRight: "auto"
}
const contImg: any = {
    width: "33.33%",

}
const contImgTop: any = {
    width: "33.33%",
    marginTop: 30
}
const contImgClients: any = {
    width: "20%",
    marginTop: 30
}
const imgProject: any = {
    // height: window.innerWidth <= 1058 ? 150 : 300,
    width: "95%",
    borderRadius: 10,
}
const imgClient: any = {
    height: window.innerWidth <= 1058 ? 30 : 70,
    width: window.innerWidth <= 1058 ? 55 : 90,
    objectFit: 'contain', 
}

const imgProjectMedium: any = {
    // height: window.innerWidth <= 1058 ? 100 : 200,
    width: "95%",
    borderRadius: 10
}
const textDescription: any = {
    fontWeight: 700,
    fontSize: window.innerWidth <= 1058 ? 14 : 20,
    textAlign: "left",
    marginTop: 5,
    marginLeft: 0,
    width: '60%', 
   
}
const textType: any = {
    fontWeight: 400,
    fontSize: window.innerWidth <= 1058 ? 14 : 20,
    marginTop: 8,
    lineHeight: 1,
    textAlign: "left",
    marginLeft: 0, 
    width: '80%', 
}
const textAcerca: any = {
    marginTop: window.innerWidth <= 1058 ? 40 : 100,
}
const textDetailAcerca: any = {
    fontSize: window.innerWidth <= 1058 ? 18 : 24,
    textAlign: "justify"
}
const containerAcerca: any = {
    width: window.innerWidth <= 1058 ? "95%" : "75%",
    marginLeft: "auto",
    marginRight: "auto",

}
const containerClients: any = {
    width: "100%",
    backgroundColor: "#000000",
    marginLeft: "auto",
    marginRight: "auto",
    height: "auto",
    alignItems: "center",
    alignContent: "center",
    marginTop: 50,
    paddingBottom: 70
}

const textClients: any = {
    marginTop: 70,
    color: "#fff",
    width: window.innerWidth <= 1058 ? "90%" : "75%",
    marginLeft: "auto",
    marginRight: "auto",
    textAlign: window.innerWidth <= 1058 ? "center" : "left",
}
const containerContacta: any = {
    width: window.innerWidth <= 1058 ? "95%" : "75%",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: 50,
}
const textcontacta: any = {
    width: window.innerWidth <= 1058 ? "70%" : "32%"
}
const buttonContacta: any = {
    width: window.innerWidth <= 1058 ? 100 : 200,
    padding:  window.innerWidth <= 1058 ? 15 : 20,
    backgroundColor: "#000000",
    color: "#ffffff",
    textAlign: "left",
    fontSize: window.innerWidth <= 1058 ? 16 : 35,
    fontWeight: 700
}
const containerPie: any = {
    width: "100%",
    backgroundColor: "#000000",
    marginLeft: "auto",
    marginRight: "auto",
    minHeight: 120,
    paddingTop: 20,
    paddingBottom: 24,
    alignItems: "center",
    alignContent: "center",
    marginTop: 50
}
const legalLinks: any = {
    width: "73%",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: 16,
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: window.innerWidth <= 1058 ? 12 : 28,
}
const legalLink: any = {
    color: "#bbbbbb",
    textDecoration: "none",
    fontSize: 14,
}
const hr: any = {
    backgroundColor: "white"
}
const contPie: any = {
    width: "73%",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 35
}
const textDetailCorreo: any = {
    height: 50,
    color: "#ffffff",
    fontSize: window.innerWidth <= 1058 ? 16 : 28,
    fontWeight: 500,
    marginTop: window.innerWidth <= 1058 ? 20 : 0,
}
const textDetailTlf: any = {
    height: 50,
    color: "#ffffff",
    fontSize: window.innerWidth <= 1058 ? 16 : 28,
    fontWeight: 500,
    marginTop: -16
}







